<coso-replicator-page-header [title]="title"></coso-replicator-page-header>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
} @if ({ isLoading: loadingService.isSpinnerActive$('loadingConfiguration') | async }; as loadingState) { @if (!loadingState.isLoading) {
<form [formGroup]="formGroup" (ngSubmit)="save()">
  <div class="card card-cns mb-3">
    <div id="header" class="card-header">Configuration details</div>
    <div id="body" class="card-body">
      <p class="text-muted">
        <small><em>All fields are required unless specified optional</em></small>
      </p>
      <input type="hidden" [formControl]="formGroup.controls.id" />
      <coso-text-input [control]="formGroup.controls.name" [inputText]="formText.name" [readonly]="isReadOnly"> </coso-text-input>
      @if (isSaaS === false) {
      <coso-text-input [control]="formGroup.controls.description" [inputText]="formText.description" [readonly]="isReadOnly"> </coso-text-input>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <a class="btn btn-secondary" [routerLink]="['/', 'configuration']"><span class="fa fa-chevron-left mr-1" aria-hidden="true"></span>Back to Configurations list</a>
    @if (!isReadOnly) {
    <button type="submit" class="btn btn-primary col-2" [disabled]="formGroup?.invalid">Save</button>
    }
  </div>
</form>
} }
